
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import CollapseItem from '@/components/collapse.vue';

import Message from '@/components/message.vue';

import Switch from '@/components/switch.vue';
import previewImg from '@/components/previewImg.vue';
import draggable from 'vuedraggable';
import uploadImg from "@/components/upload-img.vue";
import shoplist from '@/components/shoplist.vue'
import chooseCoupon from "@/components/chooseCoupon.vue"

import { imgHost } from "@/utils/config"

import {
	activityKoiFishlsave,
	activityKoiFishliinfo
} from "@/api/live";


const SPECS = [
	{ title: 'SpecTitle', key: 'SpecValue' },
	{ title: 'SpecTitle2', key: 'SpecValue2' },
	{ title: 'SpecTitle3', key: 'SpecValue3' },
	{ title: 'SpecTitle4', key: 'SpecValue4' },
	{ title: 'SpecTitle5', key: 'SpecValue5' }
];

@Component({
	name: '',
	components: {
		PageFooter,
		CollapseItem,
		'slz-message': Message,
		'slz-switch': Switch,

		previewImg,
		draggable,
		uploadImg,
		shoplist,
		chooseCoupon
	}
})


export default class KoiRaffleDetails extends Vue {
	private pageloading = false;
	private imgHost = imgHost;
	private form: any = {
		Id: 0,
		ActivityState: 0,
		Name: '',
		StartTime: '',
		EndTime: '',
		IsOpen: false,
		FullMoneyRuleType: 0,
		EveryFullMoney: undefined,
		TotalFullMoney: undefined,
		OpenPrizeTime: '',
		ReceivePrizeStartTime: '',
		ReceivePrizeEndTime: '',
		BackGroundImgUrl: '',
		BonusPoolImgUrl: '',
		BackGroundColor: '#f6f6f6',
		IsOpenShowPrizeCount: true,
		ActivityKoiFishPrizeDtoList: []
	}

	private typelist = [
		{ value: 1, label: '实物' },
		{ value: 2, label: '红包' },
		{ value: 4, label: '优惠券' },
	]
	private chooseShow = false;
	private couponList = [];
	private chooseShopShow = false;
	private chooseShopList: any = [];
	private current = 0;
	private preShow = false
	private currentUrl = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/b4bbe7470b557704b7c0de93d7bf267.png'

	private mounted() {
		if (Number(this.$route.query.Id)) {
			this.getInfo()
		}
		if (Number(this.$route.query.copyId)) {
			this.getCopyInfo()
		}
	}

	private async getInfo() {
		try {
			this.pageloading = true
			let res: any = await activityKoiFishliinfo({
				ActivityKoiFishId: this.$route.query.Id
			})
			if (res.IsSuccess) {
				let form = res.Result
				if(form.FullMoneyRuleType === 0){
					form.TotalFullMoney = undefined;
				}
				if(form.FullMoneyRuleType === 1){
					form.EveryFullMoney = undefined;
				}
				this.form = form
			}
		} finally {
			this.pageloading = false
		}
	}
	private async getCopyInfo() {
		try {
			this.pageloading = true
			let res: any = await activityKoiFishliinfo({
				ActivityKoiFishId: this.$route.query.copyId
			})
			if (res.IsSuccess) {
				let form = res.Result
				if(form.FullMoneyRuleType === 0){
					form.TotalFullMoney = undefined;
				}
				if(form.FullMoneyRuleType === 1){
					form.EveryFullMoney = undefined;
				}
				form.Id = 0;
				form.ActivityState = 0;
				this.form = form
			}
		} finally {
			this.pageloading = false
		}
	}
	private lookImg(img) {
		this.currentUrl = img
		this.preShow = true
	}
	private addprize() {
		if (this.form.ActivityKoiFishPrizeDtoList && this.form.ActivityKoiFishPrizeDtoList.length >= 100) {
			this.$message.error('最多添加100个奖品')
			return
		}
		this.form.ActivityKoiFishPrizeDtoList.push({
			Id: 0,// (int): 奖品Id,
			Sort: 0,// (int): 排序,
			PrizeType: 1,// (int) = ['实物:1' or '红包:2' or '空奖:3' or '优惠卷:4']: 奖项类型,
			PrizeName: '',// (string, optional): 奖项名称,
			PrizeDescription: '',// (string, optional): 奖品名称,
			ProductId: 0,// (int): 实物奖--对应商品Id,
			ProductName: '', // (string, optional): 实物奖--对应商品名称,
			RewardMoney: undefined,// (double): 红包奖--奖励金额,
			CouponId: 0,// (int): 优惠卷奖--对应优惠卷Id,
			CouponName: '',// (string, optional): 优惠卷奖--对应优惠卷名称,
			WinningPrizeImgUrl: '',// (string, optional): 中奖图,
			PrizeCount: undefined,// (int, optional): 奖品数量,
			ShowPrizeCount: undefined,// (int, optional): 对外展示奖品数量,
			IsJoinOpenPrize: false,// (boolean): 是否参与实际开奖
			UseRuleInstruction: ''
		})
	}
	private uploadSuc2(file, key) {
		this.form[key] = file[0]
	}
	private delprize(i) {
		this.form.ActivityKoiFishPrizeDtoList.splice(i, 1)
	}
	private uploadSuc(file, name, i, key) {
		// console.log(file,name,i,key)
		this.form.ActivityKoiFishPrizeDtoList[i][key] = file[0]
	}
	private getshop(list) {
		console.log(list)
		if (!list || !list.length) {
			this.$message.error('请选择商品')
			return
		}
		this.form.ActivityKoiFishPrizeDtoList[this.current].ProductId = list[0].Id
		this.form.ActivityKoiFishPrizeDtoList[this.current].ProductName = list[0].ProductName
		// console.log(list[0])
		this.chooseShopShow = false
	}
	private setprize(v, i) {
		this.current = i
		this.chooseShopList = v.ProductId ? [{Id: v.ProductId, ProductName: v.ProductName}] : []
		this.chooseShopShow = true
	}
	private showCouponPop(v, i) {
		this.current = i
		this.couponList = v.CouponId ? [{Id: v.CouponId, CouponName: v.CouponName}] : []
		this.chooseShow = true
	}
	private getData(list) {
		if (!list || !list.length) {
			this.$message.error('请选择优惠券')
			return
		}
		this.form.ActivityKoiFishPrizeDtoList[this.current].CouponId = list[0].Id
		this.form.ActivityKoiFishPrizeDtoList[this.current].CouponName = list[0].CouponName
		this.chooseShow = false
	}

	private async handleSave() { 
		console.log(this.form)
		try {
			this.pageloading = true
			let form = JSON.parse(JSON.stringify(this.form))
			form.ActivityKoiFishPrizeDtoList.map((item, i) => {
				item.Sort = i + 1;
				return item
			})
			if(form.FullMoneyRuleType === 0){
				form.TotalFullMoney = undefined;
			}
			if(form.FullMoneyRuleType === 1){
				form.EveryFullMoney = undefined;
			}
			
			let res: any = await activityKoiFishlsave(form)
			if (res.IsSuccess) {
				this.$message.success('保存成功')
				this.$router.go(-1)
			}
		} finally {
			this.pageloading = false
		}
	}

}
